import React from "react";
import { Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Company, CustomGetCompaniesForMergeDocument } from "generated/graphql";
import usePaginatedCompanyLookup from "hooks/companies/usePaginatedCompanyLookup";
import AutoComplete from "modules/AutoComplete/AutoComplete";
import { useMemo } from "react";
import { Controller } from "react-hook-form";

const MergeTargetCompany: React.FC<{ control: any; id: Company["id"] }> = ({ control, id }) => {
  const {
    loading: loadingCompanies,
    error: errorCompanies,
    items: companies,
    search,
    loadInitialPage,
    loadMore,
  } = usePaginatedCompanyLookup<{
    id: string;
    name: string;
    proposalsCount?: number | null;
    jobsCount?: number | null;
  }>(CustomGetCompaniesForMergeDocument, [], true, { preserveItemsOnShortSearch: true });

  const options = useMemo(() => {
    if (!companies) {
      return [];
    }

    return companies
      .filter((company) => company.id !== id)
      .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }))
      .map((company) => {
        return {
          label: `${company.name} - Proposals: ${company.proposalsCount ?? 0} - Jobs: ${
            company.jobsCount ?? 0
          }`,
          value: company.id,
        };
      });
  }, [companies]);

  return (
    <div>
      <MDBox display="flex" flexDirection="column">
        <MDBox display="flex" justifyContent="center" mb={4}>
          <Icon fontSize="large" sx={{ transform: "scale(2)" }}>
            business
          </Icon>
        </MDBox>
        <MDTypography variant="h6" component="h6" py={2}>
          Target Company to merge into
        </MDTypography>
        <Controller
          name="targetCompany"
          control={control}
          render={({ field, formState: { errors } }) => {
            const error = errors.targetCompany;
            return (
              <>
                <AutoComplete
                  options={options}
                  search={search}
                  onOpen={loadInitialPage}
                  onEndReached={loadMore}
                  field={field}
                  loading={loadingCompanies}
                  error={(error?.message ?? "") as string}
                  label="Target Company"
                  disablePortal
                />
              </>
            );
          }}
        />
      </MDBox>
    </div>
  );
};

export default MergeTargetCompany;
